export const hasLength = (length) => (value) => {
  if (value && `${value}`.length !== length) {
    return `Please enter a ${length} digit number`;
  }
  return undefined;
};

export default hasLength;
